import { fetchAuthSession } from "aws-amplify/auth"
import axios, { InternalAxiosRequestConfig } from "axios"

const api = axios.create()

// Request interceptor injects AWS access token into all API requests
api.interceptors.request.use(async (request: InternalAxiosRequestConfig) => {
    if (request.url?.includes("energynetworks.org")) {
        const session = await fetchAuthSession()
        const token = session.tokens?.accessToken?.toString()
        if (token) {
            request.headers.setAuthorization(token)
        }
    }
    return request
})

export default api
